import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import Image from "next/image";

function Workspaces(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Workspaces</HeaderH1>
      <Text>
        Your categories live inside workspaces. When you create an account, you
        begin with one workspace. To create or change the current workspaces,
        open the workspace menu located next to the categories.
      </Text>
      <ImageBlock
        src={"/guide/workspaces.gif"}
        width={746}
        height={414}
        alt={"Change categories"}
        lessRounded={true}
      />
      <Text>
        In the menu, you can create new workspaces by pressing the "New" button.
        To change the name and emoji of the workspace press the menu icon to the
        right of the workspace. You can also drag and drop the workspaces to
        change the order.
      </Text>
      <NextButton
        cta={"Share workspaces"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/share-workspaces"}
      />
    </>
  );
}

Workspaces.Layout = SideBar;

export default Workspaces;
